const CreateTeamTermEvent_mutate = `
  mutation createTeamTermEvent(
    $teamTermPeriodId: Int!
    $eventTypeId: Int!
    $name: String!
    $desc: String 
    $scheduledDate: String!
    $actualDate: String
    $attendanceRequired: Boolean!
  ) {
    createTeamTermEvent(
      teamTermPeriodId: $teamTermPeriodId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      scheduledDate: $scheduledDate,
      actualDate: $actualDate,
      attendanceRequired: $attendanceRequired
    ) {
      teamTermEvent
        {
          teamTermEventId
          name
          desc
          attendanceRequired
          teamTermPeriodId            
          {
            teamTermPeriodId
          }
          eventTypeId            
          {
            eventTypeId
            name
          }
          createBy
          createDate
          updateBy
          updateDate
        }
      }
    }
`;

const EditTeamTermEvent_mutate = `
  mutation editTeamTermEvent(
    $teamTermEventId:Int!
    $eventTypeId: Int
    $name: String
    $desc: String
    $scheduledDate: String
    $actualDate: String
    $attendanceRequired: Boolean
  ){
    editTeamTermEvent(
      teamTermEventId: $teamTermEventId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      scheduledDate: $scheduledDate,
      actualDate: $actualDate,
      attendanceRequired: $attendanceRequired
    ){
      teamTermEvent{
        teamTermEventId
        name
        desc
        attendanceRequired
        scheduledDate
        actualDate
      }
    }
  }
`;  

const DeleteTeamTermEvent_mutate = `
    mutation deleteTeamTermEvent($teamTermEventId: Int!) {
      deleteTeamTermEvent(teamTermEventId: $teamTermEventId) {
        response
      }
    }
`;

module.exports = {  
  CREATE_TEAM_TERM_EVENT_MUTATION: CreateTeamTermEvent_mutate,
  EDIT_TEAM_TERM_EVENT_MUTATION: EditTeamTermEvent_mutate,
  DELETE_TEAM_TERM_EVENT_MUTATION: DeleteTeamTermEvent_mutate,
}
